import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";


class Page400 extends Component {

  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  render = () =>
    <div className={this.props.classes.root}>
      <Typography variant="h2" style={{ fontWeight: "bold" }}>
        Oops! Something went wrong
      </Typography>
      <Typography variant="subtitle1" align="center">
        Please contact technical support at
        {" "}
        <a className={this.props.classes.link} href="mailto:support@tecorien.com">support@tecorien.com</a>
      </Typography>
      <Button onClick={() => window.location.reload()} className={this.props.classes.button}>
        Refresh page
      </Button>
    </div>;

}

export default withStyles(() => ({
  root: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
  },
  imageContainer: {
    width: "150px",
    height: "150px",
    marginBottom: "60px",
  },
  button: {
    marginTop: "100px",
    minWidth: "200px",
  },
  link: {
    color: "var(--gray-40-color)",
    "&:hover": {
      color: "var(--cheerful-blue-color)",
      textDecoration: "none",
    },
    "&:active": {
      color: "var(--ocean-color)",
    },
  },
}))(Page400);
